document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".product-showcase__option");
  const quantityInput = document.getElementById("quantity-pf");
  const priceEl = document.getElementById("price-product-pf");
  const topPriceCurrent = document.querySelector("#product-price-pf .current");
  const topComparePriceCurrent = document.querySelector("#product-price-pf .compare-at");

  const minusBtn = document.getElementById("qty-minus");
  const plusBtn = document.getElementById("qty-plus");
  const mainForm = document.getElementById("product-showcase-form-pf");

  // Sticky elements
  const sticky = document.getElementById("sticky-add-to-cart-pf");
  const stickyQtyInput = document.getElementById("sticky-quantity-pf");
  const stickyMinusBtn = document.getElementById("sticky-qty-minus");
  const stickyPlusBtn = document.getElementById("sticky-qty-plus");
  const stickyPriceEl = document.getElementById("sticky-price-product-pf");
  const stickyForm = sticky ? sticky.querySelector("form") : null;

  // Helper: money formatter using Shopify.formatMoney when available
  function formatCents(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        const moneyFormat =
          (window.theme && window.theme.strings && window.theme.strings.moneyFormat) ||
          (window.theme && window.theme.moneyFormat) ||
          (window.Shopify && window.Shopify.money_format) ||
          "${{amount}}";
        return window.Shopify.formatMoney(Math.round(cents), moneyFormat);
      }
    } catch (e) { }
    const dollars = (Math.round(cents) / 100).toFixed(2);
    return `$${dollars}`;
  }

  function getActiveOption() {
    return document.querySelector(".product-showcase__option.active") || options[0];
  }

  // Bottles model:
  // qty input = number of bottles
  // total_cents = discounted_per_bottle_cents × bottles_input
  function computeTotalCents() {
    const activeOption = getActiveOption();
    if (!activeOption) return 0;

    const perBottleDiscountedCents = parseInt(
      activeOption.getAttribute("data-discounted-price-cents"), 10
    );
    const bottles = parseInt(quantityInput.value, 10) || 1;

    const unit = isNaN(perBottleDiscountedCents) ? 0 : perBottleDiscountedCents;
    return unit * bottles;
  }

  function computeTotalCompareCents() {
    if (!topComparePriceCurrent || !topComparePriceCurrent.getAttribute("data-base-compare")) return;
    const bottles = parseInt(quantityInput.value, 10) || 1;
    const unit = topComparePriceCurrent.getAttribute("data-base-compare");
    return unit * bottles;
  }

  function updatePriceDisplay() {
    const totalCents = computeTotalCents();
    const totalCompareCents = computeTotalCompareCents();
    if (priceEl) priceEl.textContent = formatCents(totalCents);
    if (topPriceCurrent) topPriceCurrent.textContent = formatCents(totalCents);
    if (topComparePriceCurrent) topComparePriceCurrent.textContent = formatCents(totalCompareCents);
    updateStickyPrice();
  }

  // Option click: set qty input to this option's bottle qty
  options.forEach((option) => {
    option.addEventListener("click", function () {
      options.forEach((opt) => opt.classList.remove("active"));
      this.classList.add("active");
      if (quantityInput) {
        const optionBottleQty = parseInt(this.getAttribute("data-qty"), 10) || 1;
        quantityInput.value = optionBottleQty;
        quantityInput.dispatchEvent(new Event("input"));
      }
      updatePriceDisplay();
      syncStickyOption();
    });
  });

  // Quantity input (bottles)
  if (quantityInput) {
    quantityInput.addEventListener("input", function () {
      let inputQty = parseInt(this.value, 10) || 1;
      if (inputQty < 1) inputQty = 1;
      this.value = inputQty;

      // Auto-select an option if its data-qty equals the typed value
      let matched = false;
      options.forEach((option) => {
        const optionQty = parseInt(option.getAttribute("data-qty"), 10);
        if (optionQty === inputQty) {
          options.forEach((opt) => opt.classList.remove("active"));
          option.classList.add("active");
          matched = true;
        }
      });
      if (!matched) {
        options.forEach((opt) => opt.classList.remove("active"));
      }

      updatePriceDisplay();
      syncStickyQty();
    });
  }

  if (minusBtn) {
    minusBtn.addEventListener("click", function () {
      let current = parseInt(quantityInput.value, 10) || 1;
      if (current > 1) {
        quantityInput.value = current - 1;
        quantityInput.dispatchEvent(new Event("input"));
      }
    });
  }

  if (plusBtn) {
    plusBtn.addEventListener("click", function () {
      let current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = current + 1;
      quantityInput.dispatchEvent(new Event("input"));
    });
  }

  // Sticky visibility
  function handleStickyVisibility() {
    if (!sticky) return;
    if (window.innerWidth >= 768) {
      sticky.style.display = "none";
      return;
    }
    const showcase = document.querySelector("#product-showcase-form-pf");
    if (!showcase) return;
    const rect = showcase.getBoundingClientRect();
    if (rect.bottom < 0) {
      sticky.style.display = "flex";
    } else {
      sticky.style.display = "none";
    }
  }
  window.addEventListener("scroll", handleStickyVisibility);
  window.addEventListener("resize", handleStickyVisibility);
  handleStickyVisibility();

  function syncStickyQty() {
    if (!stickyQtyInput) return;
    stickyQtyInput.value = quantityInput.value;
    updateStickyPrice();
  }

  function syncStickyOption() {
    updateStickyPrice();
  }

  function updateStickyPrice() {
    if (!stickyPriceEl) return;
    const totalCents = computeTotalCents();
    stickyPriceEl.textContent = formatCents(totalCents);
  }

  // Ajax add-to-cart (fallback to native submit on failure)
  async function addToCart(formData) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: formData.get("id"),
          quantity: parseInt(formData.get("quantity"), 10) || 1
        })
      });

      if (response.ok) {
        document.dispatchEvent(new CustomEvent("cart:open"));

        const cartDrawerTrigger =
          document.querySelector("[data-cart-drawer-toggle]") ||
          document.querySelector(".cart-drawer-toggle") ||
          document.querySelector("#cart-drawer-toggle");
        if (cartDrawerTrigger) cartDrawerTrigger.click();

        document.dispatchEvent(new CustomEvent("theme:cart:open"));
        document.dispatchEvent(new CustomEvent("cart-drawer:open"));

        if (typeof window.openCartDrawer === "function") window.openCartDrawer();
        if (typeof window.theme?.cart?.open === "function") window.theme.cart.open();

        return true;
      }
      throw new Error("Failed to add to cart");
    } catch (error) {
      console.error("Error adding to cart:", error);
      return false;
    }
  }

  if (stickyQtyInput) {
    stickyQtyInput.addEventListener("input", function () {
      let val = parseInt(stickyQtyInput.value, 10) || 1;
      if (val < 1) val = 1;
      stickyQtyInput.value = val;
      quantityInput.value = val;
      quantityInput.dispatchEvent(new Event("input"));
      updateStickyPrice();
    });
  }

  if (stickyMinusBtn) {
    stickyMinusBtn.addEventListener("click", function () {
      let current = parseInt(stickyQtyInput.value, 10) || 1;
      if (current > 1) {
        stickyQtyInput.value = current - 1;
        stickyQtyInput.dispatchEvent(new Event("input"));
      }
    });
  }

  if (stickyPlusBtn) {
    stickyPlusBtn.addEventListener("click", function () {
      let current = parseInt(stickyQtyInput.value, 10) || 1;
      stickyQtyInput.value = current + 1;
      stickyQtyInput.dispatchEvent(new Event("input"));
    });
  }

  options.forEach((option) => {
    option.addEventListener("click", function () {
      syncStickyOption();
      syncStickyQty();
    });
  });

  if (stickyForm) {
    stickyForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      if (stickyQtyInput && quantityInput) {
        quantityInput.value = stickyQtyInput.value;
      }
      const formData = new FormData(this);
      const success = await addToCart(formData);
      if (!success) this.submit();
    });
  }

  if (mainForm) {
    mainForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      const formData = new FormData(this);
      const success = await addToCart(formData);
      if (!success) this.submit();
    });
  }

  // Initial sync
  updatePriceDisplay();
  updateStickyPrice();
  syncStickyQty();
});


// FAQ accordion
document.addEventListener("DOMContentLoaded", function () {
  const faqHeaders = document.querySelectorAll(".product-showcase__faq-header");
  if (faqHeaders.length === 0) return;

  const firstHeader = faqHeaders[0];
  const firstItem = firstHeader.closest(".product-showcase__faq-item");
  let firstContent = null;
  if (firstItem) {
    firstContent = firstItem.querySelector(".product-showcase__faq-content");
    if (!firstContent) {
      firstContent = firstHeader.nextElementSibling;
    }
  }
  const firstArrow = firstHeader.querySelector(".arrow-down");
  if (firstContent && firstArrow) {
    firstContent.style.display = "block";
    firstArrow.classList.add("active");
  }

  faqHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      document
        .querySelectorAll(".product-showcase__faq-content")
        .forEach((content) => {
          content.style.display = "none";
        });
      document
        .querySelectorAll(".product-showcase__faq-header .arrow-down")
        .forEach((arrow) => {
          arrow.classList.remove("active");
        });

      const faqItem = this.closest(".product-showcase__faq-item");
      let content = null;
      if (faqItem) {
        content = faqItem.querySelector(".product-showcase__faq-content");
        if (!content) {
          content = this.nextElementSibling;
        }
      }
      const arrow = this.querySelector(".arrow-down");
      if (content && arrow) {
        content.style.display = "block";
        arrow.classList.add("active");
      }
    });
  });
});


// Gallery / modal logic
document.addEventListener("DOMContentLoaded", function () {
  function getFirstVideoIndex(slidesSelector) {
    var slides = document.querySelectorAll(slidesSelector);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains("product-video-slide")) {
        return i;
      }
    }
    return -1;
  }

  var thumbsSwiper = new Swiper(".thumbs-swiper", {
    spaceBetween: 10,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    navigation: {
      nextEl: ".thumbs-next",
      prevEl: ".thumbs-prev",
    },
  });

  var mainSwiper = new Swiper(".main-swiper", {
    spaceBetween: 10,
    autoHeight: true,
    thumbs: { swiper: thumbsSwiper },
  });

  document
    .querySelector(".main-swiper .swiper-wrapper")
    .addEventListener("click", function (e) {
      var slide = e.target.closest(".swiper-slide");
      if (!slide) return;

      if (
        slide.classList.contains("product-video-slide") ||
        e.target.closest(".video-trigger") ||
        e.target.closest(".modal-play-btn")
      ) {
        return;
      }

      var slides = Array.from(
        document.querySelectorAll(".main-swiper .swiper-slide")
      );
      var idx = slides.indexOf(slide);
      if (idx !== -1) {
        openGalleryModal(idx);
      }
    });

  var modal = document.getElementById("gallery-modal");
  var modalSwiperWrapper = modal.querySelector(".modal-swiper .swiper-wrapper");
  var modalSwiper = null;

  function openGalleryModal(startIndex = 0, autoPlayVideo = false) {
    modalSwiperWrapper.innerHTML = "";

    if (modalSwiper) {
      modalSwiper.destroy(true, true);
      modalSwiper = null;
    }

    var mainSlides = document.querySelectorAll(
      window.innerWidth >= 768
        ? ".main-swiper-desktop .swiper-slide"
        : ".main-swiper .swiper-slide"
    );

    mainSlides.forEach(function (slide, idx) {
      var isVideo = slide.classList.contains("product-video-slide");
      var clone = document.createElement("div");
      clone.className =
        "swiper-slide" + (isVideo ? " product-video-slide" : "");

      if (isVideo) {
        var videoUrl = slide.getAttribute("data-video");
        var thumbImg = slide.querySelector(".gallery-video-thumb");
        clone.setAttribute("data-video", videoUrl);

        if (autoPlayVideo && idx === startIndex) {
          clone.innerHTML = `
          <video controls autoplay style="max-width:100%;max-height:80vh;display:block;margin:0 auto;">
            <source src="${videoUrl}" type="video/mp4">
            Your browser does not support video.
          </video>
        `;
        } else {
          clone.innerHTML = `
          <div class="video-thumb-wrapper">
            <img src="${thumbImg ? thumbImg.src : ""}" alt="Video" class="gallery-video-thumb">
            <img src="${slide.querySelector(".play-icon")
              ? slide.querySelector(".play-icon").src
              : ""
            }" alt="Play" class="play-icon play-icon-thumb">
          </div>
          <button class="modal-play-btn">
            <img src="https://cdn.shopify.com/s/files/1/0549/4341/6354/files/play-circle.svg" alt="Play">
          </button>
        `;
        }
      } else {
        var img = slide.querySelector("img.gallery-image");
        var trigger = slide.querySelector(".video-trigger");
        clone.innerHTML = img ? img.outerHTML : "";
        if (trigger) clone.innerHTML += trigger.outerHTML;
      }

      modalSwiperWrapper.appendChild(clone);
    });

    modal.classList.add("active");

    modalSwiper = new Swiper(".modal-swiper", {
      initialSlide: startIndex,
      navigation: {
        nextEl: ".modal-swiper .swiper-button-next",
        prevEl: ".modal-swiper .swiper-button-prev",
      },
      spaceBetween: 10,
    });

    setTimeout(function () {
      var modalSlides = modalSwiperWrapper.querySelectorAll(".swiper-slide");
      modalSlides.forEach(function (slide, idx) {
        var playBtn = slide.querySelector(".modal-play-btn");
        if (playBtn) {
          playBtn.addEventListener("click", function (e) {
            e.stopPropagation();
            var videoUrl = slide.getAttribute("data-video");
            if (videoUrl) {
              modal.classList.remove("active");
              if (modalSwiper) {
                modalSwiper.destroy(true, true);
                modalSwiper = null;
              }
              modalSwiperWrapper.innerHTML = "";
              setTimeout(function () {
                openGalleryModal(idx, true);
              }, 200);
            }
          });
        }
      });
    }, 100);
  }

  document
    .querySelectorAll(".main-swiper .video-trigger")
    .forEach(function (trigger) {
      trigger.addEventListener("click", function (e) {
        e.stopPropagation();
        var firstVideoIdx = getFirstVideoIndex(".main-swiper .swiper-slide");
        if (firstVideoIdx !== -1) {
          openGalleryModal(firstVideoIdx, true);
        }
      });
    });

  modal
    .querySelector(".gallery-modal-close")
    .addEventListener("click", function () {
      modal.classList.remove("active");
      if (modalSwiper) {
        modalSwiper.destroy(true, true);
        modalSwiper = null;
      }
      modalSwiperWrapper.innerHTML = "";
    });
  modal
    .querySelector(".gallery-modal-overlay")
    .addEventListener("click", function () {
      modal.classList.remove("active");
      if (modalSwiper) {
        modalSwiper.destroy(true, true);
        modalSwiper = null;
      }
      modalSwiperWrapper.innerHTML = "";
    });

  if (window.innerWidth >= 768) {
    const verticalThumbs = new Swiper(".thumbs-swiper-vertical", {
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 15,
      freeMode: false,
      watchSlidesProgress: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".thumbs-vertical-next",
        prevEl: ".thumbs-vertical-prev",
      },
      mousewheel: false,
      preventInteractionOnTransition: true,
      slideToClickedSlide: true,
      breakpoints: {
        768: { direction: "vertical", slidesPerView: "auto", autoHeight: false },
      },
    });

    const mainDesktopSwiper = new Swiper(".main-swiper-desktop", {
      spaceBetween: 10,
      thumbs: { swiper: verticalThumbs },
    });

    document
      .querySelector(".main-swiper-desktop .swiper-wrapper")
      .addEventListener("click", function (e) {
        var slide = e.target.closest(".swiper-slide");
        if (!slide) return;

        if (
          slide.classList.contains("product-video-slide") ||
          e.target.closest(".video-trigger") ||
          e.target.closest(".modal-play-btn")
        ) {
          return;
        }

        var slides = Array.from(
          document.querySelectorAll(".main-swiper-desktop .swiper-slide")
        );
        var idx = slides.indexOf(slide);
        if (idx !== -1) {
          openGalleryModal(idx);
        }
      });

    document
      .querySelectorAll(".main-swiper-desktop .video-trigger")
      .forEach(function (trigger) {
        trigger.addEventListener("click", function (e) {
          e.stopPropagation();
          var firstVideoIdx = getFirstVideoIndex(
            ".main-swiper-desktop .swiper-slide"
          );
          if (firstVideoIdx !== -1) {
            openGalleryModal(firstVideoIdx, true);
          }
        });
      });
  }

  document
    .querySelectorAll(".swiper-slide.product-video-slide .play-icon")
    .forEach((playIcon) => {
      playIcon.addEventListener("click", function (e) {
        e.stopPropagation();
        const slide = this.closest(".swiper-slide.product-video-slide");
        if (!slide) return;

        const videoUrl = slide.getAttribute("data-video");
        if (!videoUrl) return;

        slide.innerHTML = `
      <video controls autoplay muted playsinline style="width: 100%; height: auto; display: block;">
        <source src="${videoUrl}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    `;
      });
    });
});